/**
 * This composable animation methods
 * It's not meant to be used directly.
 *
 */
export const useTransitionExpand = () => {
  /**
   * expandTransition duration, to be overridden in the mounted() hook whenever we want the
   * duration of the transition to last more/less
   */
  const expandTransitionDuration = ref('300ms')

  const setExpandTransitionDuration = (duration) => {
    expandTransitionDuration.value = duration
  }

  const afterEnter = (element) => {
    element.style.height = 'auto'
  }
  const enter = (element) => {
    const width = getComputedStyle(element).width
    element.style.width = width
    element.style.position = 'absolute'
    element.style.visibility = 'hidden'
    element.style.height = 'auto'

    const height = getComputedStyle(element).height

    element.style.width = null
    element.style.position = null
    element.style.visibility = null
    element.style.height = 0
    element.style.opacity = 0
    element.style.transition = `all ${expandTransitionDuration.value}`

    /* Force repaint to make sure the animation is triggered correctly. */
    // eslint-disable-next-line no-unused-expressions
    getComputedStyle(element).height

    /** Trigger the animation.
     * We use `requestAnimationFrame` because we need
     * to make sure the browser has finished
     * painting after setting the `height`
     * to `0` in the line above.
     */
    requestAnimationFrame(() => {
      element.style.transitionTimingFunction = 'cubic-bezier(.63, .01, 1, 1.01)'
      element.style.height = height
      element.style.opacity = 1
    })
  }

  const leave = (element) => {
    const height = getComputedStyle(element).height

    element.style.height = height

    /* Force repaint to make sure the animation is triggered correctly. */
    // eslint-disable-next-line no-unused-expressions
    getComputedStyle(element).height

    requestAnimationFrame(() => {
      element.style.transitionTimingFunction = 'cubic-bezier(.63, .01, 1, 1.01)'
      element.style.height = 0
      element.style.opacity = 0
    })
  }

  return {
    setExpandTransitionDuration,
    leave,
    enter,
    afterEnter
  }
}
